import {Injectable} from "@angular/core";
import {ApiService} from "../../../services/api/api.service";
import {IMernisQuery} from "../interfaces/mernis-query.interface";

@Injectable({
  providedIn: 'root'
})
export class MernisQueryService {
  constructor(private readonly apiService: ApiService) {
  }

  getMernisUserData(data: IMernisQuery){
    const params = new URLSearchParams();

    // Değerleri string olarak ekle
    if (data.tckn) params.append('tckn', String(data.tckn));
    if (data.birthDay) params.append('birthDay', String(data.birthDay));
    if (data.birthMonth) params.append('birthMonth', String(data.birthMonth));
    if (data.birthYear) params.append('birthYear', String(data.birthYear));

    // Query string'i oluştur ve API isteği yap
    const queryString = params.toString();

    return this.apiService.get(`mernis/check-mernis-user-exist?${queryString}`);
  }
}
